<template>
  <Modal @close="$emit('close')">
    <template slot="header">
      <div v-for="question in questions" :key="question.key">
        {{question.question}}
      </div>
    </template>

    <div slot="body" class="rq-body">
      <div v-for="question in questions" :key="question.key" class="rq-question">
        <div class="rq-options">
          <label v-for="(option, index) in question.options" :key="index"
                 class="rq-option"
                 :for="`${question.key}_${index}`">
            <input type="radio"
                   :id="`${question.key}_${index}`"
                   :name="question.key"
                   :value="option"
                   v-model="selectedAnswers[question.key]">
            <span>{{option}}</span>
          </label>
        </div>
      </div>
    </div>

    <div slot="footer" class="rq-footer">
      <button type="button" class="btn btn-neutral" @click="$emit('close')">
        Cancel
      </button>
      <button type="button" class="btn btn-primary"
              :disabled="!allAnswered"
              @click="confirm">
        Continue to download
      </button>
    </div>
  </Modal>
</template>


<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'ReportQuestionsModal',
  components: { Modal },

  props: {
    questions: { type: Array, default: () => [] },
  },

  data() {
    return {
      // Vue 2 reactivity needs the keys to exist up front when bound via
      // v-model[obj[key]]. Pre-seed an empty string per question.
      selectedAnswers: Object.fromEntries(
        this.questions.map((question) => [question.key, '']),
      ),
    };
  },

  computed: {
    allAnswered() {
      return this.questions.length > 0
        && this.questions.every(
          (question) => Boolean(this.selectedAnswers[question.key]),
        );
    },
  },

  methods: {
    confirm() {
      if (!this.allAnswered) return;
      this.$emit('confirm', { ...this.selectedAnswers });
    },
  },
};
</script>


<style scoped>
.rq-body {
  font-family: Helvetica, Arial, sans-serif;
  color: rgba(0, 0, 0, 0.85);
}
.rq-question + .rq-question {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.rq-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rq-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.rq-option:hover {
  border-color: rgba(0, 0, 0, 0.35);
  background-color: rgba(0, 0, 0, 0.02);
}
.rq-option input[type="radio"] {
  margin: 0;
  flex-shrink: 0;
}

.rq-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
